import { render, staticRenderFns } from "./MenuBargaining.vue?vue&type=template&id=f363cba8&"
import script from "./MenuBargaining.vue?vue&type=script&lang=js&"
export * from "./MenuBargaining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports